<form [formGroup]="dadProductForm" class="popup-form">

  <div class="popup-body">

    <div class="field-group">
      <label for="market">Market</label>
      <p-dropdown [options]="marketsList" [style]="{width: '100%'}"
                  formControlName="market" id="market"
                  placeholder="Select a market"></p-dropdown>
    </div>

    <div class="field-group">
      <label for="productType">Product type</label>
      <p-dropdown [options]="productTypesList" [style]="{width: '100%'}"
                  formControlName="productType" id="productType"
                  placeholder="Select a type"></p-dropdown>
    </div>

    <div class="field-row">
      <div class="field-group">
        <label for="productCode">Product code</label>
        <input class="form-control" formControlName="productCode" id="productCode"
               placeholder="e.g. NYSE123" type="text">
        <span class="field-error"
              *ngIf="dadProductForm.get('productCode').touched && dadProductForm.get('productCode').errors">
          Required.
        </span>
      </div>

      <div class="field-group">
        <label for="startDate">Valid from</label>
        <p-calendar dateFormat="dd/mm/yy" formControlName="startDate" id="startDate"
                    [style]="{width: '100%'}" appendTo="body"
                    panelStyleClass="sym-datepicker sym-datepicker-sm"></p-calendar>
      </div>
    </div>

  </div>

  <div class="popup-footer">
    <button (click)="onSubmit()" class="btn btn-primary" [disabled]="dadProductForm.invalid">
      <ng-container *ngIf="!isEditDadProduct">
        <i class="fa fa-plus-circle"></i> Add Product
      </ng-container>
      <ng-container *ngIf="isEditDadProduct">
        <i class="fa fa-check"></i> Save Changes
      </ng-container>
    </button>
  </div>

</form>
